import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const BoardSetup = ({ board, sensor, actuator , sensorName}) => {
  return (
    <div className='d-flex justify-content-between'>
      <OverlayTrigger
        placement='top'
        overlay={
          <Tooltip id={`tooltip-top`}>
            You soon will be able to select more Sensors
          </Tooltip>
        }
      >
        <div className='col-lg-4'>
          <img
            src={sensor}
            className='card-img-top img-thumbnail'
            alt={sensorName}
          />
        </div>
      </OverlayTrigger>
      <OverlayTrigger
        placement='top'
        overlay={
          <Tooltip id={`tooltip-top`}>
            You soon will be able to select more Microcontrollers
          </Tooltip>
        }
      >
        <div className='col-lg-4'>
          <img
            src={board}
            className='card-img-top img-thumbnail'
            alt={sensorName}
          />
        </div>
      </OverlayTrigger>
      <OverlayTrigger
        placement='top'
        overlay={
          <Tooltip id={`tooltip-top`}>
            You soon will be able to select more Displays
          </Tooltip>
        }
      >
        <div className='col-lg-4'>
          <img
            src={actuator}
            className='card-img-top img-thumbnail'
            alt={sensorName}
          />
        </div>
      </OverlayTrigger>
    </div>
  );
};

export default BoardSetup